<template>
    <div class="animate__animated animate__fadeInUp">
        <v-card-title><span v-html="$th('support.faq.title')"></span></v-card-title>

        <v-expansion-panels popout focusable style="width:100%">
            <v-expansion-panel v-for="(entry, index) in get_list('support.faq.faq')"
                               :key="index">
                <v-expansion-panel-header><span v-html="entry.q"></span></v-expansion-panel-header>
                <v-expansion-panel-content class="mt-5">
                    <span v-html="entry.a"></span>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
    export default {
        methods: {
            // Returns the list behind a translation key, an empty list when the key does not exist
            get_list(key) {
                const list = this.$t(key);
                return Array.isArray(list) ? list : [];
            },
        },
        metaInfo() {
            return {
                title: `${this.$t('meta.page-title-unformated')} - ${this.$t('meta.page-title-faq')}`,
                meta : [{
                    name   : "description",
                    content: this.$t("meta.description"),
                }]
            }
        },
    }
</script>